import { render, staticRenderFns } from "./Hotspot.vue?vue&type=template&id=53697b0b&scoped=true"
import script from "./Hotspot.vue?vue&type=script&lang=ts"
export * from "./Hotspot.vue?vue&type=script&lang=ts"
import style0 from "./Hotspot.vue?vue&type=style&index=0&id=53697b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53697b0b",
  null
  
)

export default component.exports